import React from 'react';

const BankIcon = ({
    color = "#757575",
    height = 16,
    width = 16
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={`${width}`} height={`${height}`} viewBox="0 0 16 16" fill="none">
            <path d="M1.5 6H14.5L8 2L1.5 6Z" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.5 6V11" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.5 6V11" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 6V11" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.5 6V11" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 11H14" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 13H15" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default BankIcon;